import React from 'react'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

export default function Forbidden() {
  return (
    <>
      <Helmet>
        <title>403 Ingen adgang - Recars ApS</title>
        <meta name="description" content="Du har ikke adgang til denne side." />
      </Helmet>

      <section className="relative min-h-screen flex items-center justify-center bg-dark-950 px-4">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(239,68,68,0.05),transparent_50%)]" />
        
        <div className="relative z-10 text-center max-w-md mx-auto">
          <div className="flex h-20 w-20 items-center justify-center rounded-full bg-red-500/10 border border-red-500/20 text-red-500 mx-auto mb-8 animate-bounce">
            <i className="fa-solid fa-lock-keyhole text-3xl" />
          </div>
          
          <h1 className="font-display text-4xl font-extrabold text-white tracking-tight sm:text-5xl">
            403
          </h1>
          <h2 className="mt-4 font-display text-lg font-bold text-[#c5a880] uppercase tracking-wider">
            Adgang nægtet
          </h2>
          <p className="mt-4 text-sm text-slate-400 leading-relaxed">
            Du har desværre ikke de nødvendige tilladelser til at se denne side. Hvis du mener, at dette er en fejl, bedes du kontakte os.
          </p>
          
          <div className="mt-10 flex justify-center gap-4">
            <Link
              to="/"
              className="rounded-xl bg-[#c5a880] px-6 py-3.5 text-xs font-bold uppercase tracking-wider text-black hover:bg-[#b39368] transition-all duration-300"
            >
              Gå til forsiden
            </Link>
            <Link
              to="/kontakt"
              className="rounded-xl border border-dark-700 bg-dark-900 px-6 py-3.5 text-xs font-bold uppercase tracking-wider text-white hover:bg-dark-800 transition-all duration-300"
            >
              Kontakt os
            </Link>
          </div>
        </div>
      </section>
    </>
  )
}
